import React from "react";

const ContactUs = () => {
  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h2
            style={{
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "Roboto",
              fontWeight: "bold",
            }}
          >
            Contact Us
          </h2>

          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    Developer: Sanskruti Reddy Donthi
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    Advisor: Dr. Shelby Funk
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    In case of any issues, fill out this{" "}
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLSfXbd-pQn5ob1wfo-xRbexIFKmgY7go4ReTEnP6QmdRlwLuvA/viewform?usp=sf_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontFamily: "Roboto" }}
                    >
                      form
                    </a>{" "}
                    and please place screenshots for better understanding.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
